<template>
    <div>
        <config-main-title>
            Campos Customizados
        </config-main-title>

        <div v-if="!item">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir
                    </button>
                </div>
            </div>

            <div v-if="( !lista || !lista.length )">
                <az-empty-state 
                    :msg="'Nenhuma configuração identificada.'" 
                    icon="fas fa-search"
                    :action="'Incluir'" 
                    :method="incluir" />
            </div>

            <div v-else>
                <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(form, ifx) in lista" :key="ifx">
                        <div>
                            <a href="#" @click.prevent="validate = false; item = form" class="h5 card-link mb-0 mr-3">
                                {{ form.search }}
                            </a>

                            <span class="badge badge-secondary" v-if="form.filtros && form.filtros.length">
                                <i class="fa fa-filter" aria-hidden="true"></i>
                                {{ form.filtros.length }}
                            </span>
                        </div>
                        <span>
                            <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input" 
                                    :id="'ativo-' + ifx" 
                                    v-model="form.fl_ativo" 
                                    @change="toggle(form)">
                                <label class="custom-control-label" :for="'ativo-' + ifx"></label>
                            </div>
                            <div v-else>
                                {{ area(form) }}
                            </div>
                        </span>
                    </li>
                </ul>
            </div>

        </div>

        <div v-else>

            <div class="card">
                <div class="card-header" :class="item.id_campos_customizados ? '' : 'bg-success text-white'">
                    {{ item.id_campos_customizados ? item.st_titulo : 'Novo' }}
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col col-12 col-md-6">
                            <az-input
                                label="Título"
                                required 
                                :validate="validate"
                                v-model="item.st_titulo" />
                        </div>
                        <div class="col col-12 col-md-6">
                            <az-input
                                label="Local"
                                type="select"
                                optionsMode="json"
                                :optionsList="opcoes"
                                optionsData="id"
                                required 
                                :validate="validate"
                                v-model="item.model_type" />
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col col-12">
                            <formulario 
                                :campocustompaciente="item.model_type == 'App\\azure\\pessoa'"
                                v-model="item.js_campos" 
                                :saved="saved" 
                                :config="true" 
                                @atualizar="refresh()" />
                        </div>
                    </div>

                    <!-- Filtros de Exibição da Recepção -->
                    <div class="mt-3" v-if="item.model_type == 'App\\azure\\pessoa' || item.model_type == 'App\\azure\\estoqueSolicitacao' || item.model_type == 'App\\azure\\marcacao'">
                        <filtro-model 
                            v-model="item.filtros" 
                            :validate="validate" 
                            :opcoes="lista_opcoes_filtro" />
                    </div>
                </div>
                <div class="modal-footer">
                    <az-audit-log-button model="camposCustomizados" :id="item.id_campos_customizados" />
                    <button type="button" class="btn btn-secondary" @click="item = null">Fechar</button>
                    <az-submit @click="atualizar ()">{{ item.id_campos_customizados ? 'Atualizar' : 'Incluir' }}</az-submit>
                </div>
            </div>
            
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import Formulario from '../../modulos/consultorio/Formulario.vue';
import FiltroModel from '../shared/FiltroModel.vue';

export default {
    data() { 
        return { 
            dados: null, 
            search: "", 
            viewMode: "A", 
            item: null, 
            saved: true, 
            validate: false, 
            breadcrumb: null, 
        }
    },

    components: { 
        AzInput, 
        AzEmptyState,
        AzSubmit, 
        ConfigMainTitle,
        Formulario, 
        AzAuditLogButton, 
        FiltroModel, 
    },

    computed: { 
        lista: function () { 
            if ( !this.dados ) 
                return [];

            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados.filter(item => this.viewMode == 'T' || item.fl_ativo)
                .filter(item => ( !this.search || reg.test(JSON.stringify(item)) ));
        }, 

        opcoes: function () { 
            return [
                { id: 'App\\azure\\apoiado', search: 'Apoiado' },
                { id: 'App\\azure\\fornecedor', search: 'Fornecedor' },
                { id: 'App\\azure\\estoqueItem', search: 'Item de Estoque' },
                { id: 'App\\azure\\internacao', search: 'Internação' },
                { id: 'App\\azure\\lancamento', search: 'Lançamento Financeiro' },
                { id: 'App\\azure\\marcacao', search: 'Marcação' },
                { id: 'App\\azure\\operadora', search: 'Operadora' },
                { id: 'App\\azure\\pessoa', search: 'Paciente' },
                { id: 'App\\azure\\pagamentoAtendimento', search: 'Pagamento Particular' },
                { id: 'App\\azure\\procedimento', search: 'Procedimento' },
                { id: 'App\\azure\\medico', search: 'Prestador' },
                { id: 'App\\azure\\medicoSolicitante', search: 'Profissional Solicitante' },
                { id: 'App\\azure\\equipamento', search: 'Recurso' },
                { id: 'App\\azure\\estoqueSolicitacao', search: 'Solicitação de Mat/Med (Suprimentos)' },
                { id: 'App\\azure\\unidadeOperacao', search: 'Unidade' },
                { id: 'App\\azure\\usuario', search: 'Usuário' },
            ];
        }, 

        lista_opcoes_filtro: function () { 
        
            let opcoes = [];

            switch (this.item.model_type) {
                case "App\\azure\\pessoa":
                    opcoes = [
                        {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                        {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                    ];
                    break;

                case "App\\azure\\marcacao":
                    opcoes = [
                        {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                        {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                        {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                        {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                        {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                        {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
                        {id:'App\\azure\\unidadeOperacao', search:'Unidade', service:'unidade_operacaos.index'},
                    ];
                    break;

                case "App\\azure\\estoqueSolicitacao":
                    opcoes = [
                        {id:'App\\azure\\estoqueItem', search:'Item de Estoque', service: 'estoque_itens.index'}, 
                        {id:'App\\azure\\estoqueTipoMovimentacao', search:'Tipo de Movimentação', service: 'estoque_tipo_movimentacaos.index', parms: { solic: true }}, 
                        {id:'App\\azure\\unidadeOperacao', search:'Unidade', service:'unidade_operacaos.index'},
                    ];
                    break;
            }

            return _.orderBy(opcoes, 'search');
             
        },

    },

    methods: { 
        area(form) { 
            let area = this.opcoes.find(item => item.id == form.model_type);

            return area ? area.search : '';
        },

        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'campos_customizados',
                dados: item,
            });

        },

        refresh() { 

        },

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'campos_customizados',
                dados: this.item, 
                toast: true, 
                callback: () => { 
                    this.item = null;
                    this.load();
                }
            });
        },

        incluir () { 
            this.validate = false; 

            this.item = { 
                id_campos_customizados: null, 
                st_titulo: "", 
                model_type: "", 
                js_campos: [],
                fl_ativo: true, 
                filtros: [], 
            }
        },

        load() { 
            this.$util.load(this, { 
                service: "campos_customizados",
                parms: { 
                    cadastro: true, 
                }
            })
        }
    },

    mounted() { 
        this.load();

        this.breadcrumb = [
            { name: "Configurações", path: "/cadastros"},
            { name: "Campos Customizados" },
        ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);
    }
}
</script>